export interface MapPoint {
  lat: number
  lng: number
  name?: string
  description?: string
}

export const isValidPoint = (point: any): point is MapPoint => {
  return (
    point != null &&
    typeof point === 'object' &&
    typeof point.lat === 'number' &&
    !isNaN(point.lat) &&
    typeof point.lng === 'number' &&
    !isNaN(point.lng) &&
    !(point.lat === 0 && point.lng === 0)
  )
}

export const sanitizePoints = (points: any[]): MapPoint[] => {
  if (!Array.isArray(points)) return []
  return points.filter(isValidPoint)
}

export const findOverlappingPinIndexes = (points: MapPoint[]): number[] => {
  const seen = new Map<string, number>()
  const overlaps = new Set<string>()
  const resultIndexes: number[] = []

  points.forEach((point, index) => {
    const { lat, lng } = point
    const key = `${lat},${lng}`

    if (seen.has(key)) {
      if (!overlaps.has(key)) {
        overlaps.add(key)
        resultIndexes.push(seen.get(key)!)
      }
    } else {
      seen.set(key, index)
    }
  })

  return resultIndexes
}
